// extracted by mini-css-extract-plugin
module.exports = {"manualAction":"CarManualActions_manualAction__3A79t","icon":"CarManualActions_icon__2lple","adminStatus":"CarManualActions_adminStatus__1dkzS"};